import { ruMonthDictionary } from './constants';

export const transformDateArr = (d: string[]): string => {
  let [day, month, year] = d;

  if (day?.length === 1) {
    day = `0${day}`;
  }

  if (month?.length === 1) {
    month = `0${month}`;
  }

  if (year?.length === 2) {
    year = `20${year}`;
  }

  if (!year) {
    year = `2024`;
  }

  return `${year}.${month}.${day}`;
};

export const replaceRus = (d: string[]): string[] => {
  ruMonthDictionary.forEach((el, i) => {
    if (el.includes(d?.[1])) {
      d[1] = `${i < 10 ? 0 : ''}${i + 1}`;
    }
  });
  return d;
};

export const dateStringToArr = (d: string): string[] => {
  if (d.includes('.')) {
    return d.split('.');
  }

  if (d.includes('-')) {
    return d.split('-');
  }

  if (d.includes('/')) {
    return d.split('/');
  }

  return d.split(' ');
};

const padDatePart = (value: number): string => value.toString().padStart(2, '0');

const normalizeYear = (value: string): number | null => {
  if (!/^\d{2}$|^\d{4}$/.test(value)) {
    return null;
  }

  const year = Number(value.length === 2 ? `20${value}` : value);
  return Number.isInteger(year) && year >= 1 ? year : null;
};

const buildNormalizedDate = (
  dayValue: string,
  monthValue: string,
  yearValue: string,
): string | null => {
  const day = Number(dayValue);
  const month = Number(monthValue);
  const year = normalizeYear(yearValue);

  if (!Number.isInteger(day) || !Number.isInteger(month) || year === null) {
    return null;
  }

  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }

  return `${padDatePart(day)}-${padDatePart(month)}-${year}`;
};

export const normalizeDateInput = (value?: string | number | null): string | null => {
  if (value === null || value === undefined) {
    return null;
  }

  const firstClipboardCell = String(value)
    .replace(/\u00a0/g, ' ')
    .split(/\r?\n|\t/)
    .map(part => part.trim())
    .find(Boolean);

  if (!firstClipboardCell) {
    return null;
  }

  const dateTimeMatch = firstClipboardCell.match(
    /^(.+?)(?:[T\s]+\d{1,2}:\d{2}(?::\d{2})?(?:\.\d+)?Z?)?$/,
  );
  const input = (dateTimeMatch?.[1] || firstClipboardCell).trim();

  const yearFirstMatch = input.match(/^(\d{4})[./-](\d{1,2})[./-](\d{1,2})$/);
  if (yearFirstMatch) {
    return buildNormalizedDate(yearFirstMatch[3], yearFirstMatch[2], yearFirstMatch[1]);
  }

  const dayFirstMatch = input.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{2}|\d{4})$/);
  if (dayFirstMatch) {
    return buildNormalizedDate(dayFirstMatch[1], dayFirstMatch[2], dayFirstMatch[3]);
  }

  return null;
};
